import { render, staticRenderFns } from "./AddRowAbove.vue?vue&type=template&id=5c5a667f&"
import script from "./AddRowAbove.vue?vue&type=script&lang=js&"
export * from "./AddRowAbove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports